import PropTypes from 'prop-types';

const ActionButton = ({ className = 'action_button', icon, label, onClick, labelClass, title }) => (
   <button className={className} onClick={onClick} title={title}>
      <i className="ct-icon ct-lg">{icon}</i>
      <span className={labelClass}>{label}</span>
   </button>
);

export default ActionButton;

ActionButton.propTypes = {
   className: PropTypes.string,
   icon: PropTypes.node.isRequired,
   label: PropTypes.string,
   onClick: PropTypes.func.isRequired,
   labelClass: PropTypes.string,
   title: PropTypes.string,
};
